import React, {Fragment, useEffect, useState } from 'react';
import FormAutocompletarMultiple from 'components/formulario/FormAutocompletarMultiple';
import FormControlDeContrasena from 'components/formulario/FormControlDeContrasena';
import FormControlDeEntrada from 'components/formulario/FormControlDeEntrada';
import FormSelectorDeFechas from 'components/formulario/FormSelectorDeFechas';
import FormControlNumerico from 'components/formulario/FormControlNumerico';
import FormAutocompletar from "components/formulario/FormAutocompletar";
import {Icon, Button, CircularProgress, Alert } from '@mui/material/';
import FormSeleccionar from 'components/formulario/FormSeleccionar';
import FormAreaTexto from 'components/formulario/FormAreaTexto';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import CancelIcon from '@mui/icons-material/Cancel';
import FormInputArchivos from './FormInputArchivos';
import SaveIcon from '@mui/icons-material/Save';
import FormBotonRadio from './FormBotonRadio';
import InputCheckbox from './FormCheckbox';
import clsx from 'clsx';
import {estilos} from './estilos';

export default function Formulario(props) {
    const classes = estilos(props);
    const labelTieneAsterisco = (label) => typeof label === 'string' && label.includes('*');

    const normalizarCamposObligatorios = (sourceElements = {}) => {
        const normalizedElements = {};

        Object.keys(sourceElements).forEach((key) => {
            const sourceElement = sourceElements[key] || {};
            const element = { ...sourceElement };

            if (!labelTieneAsterisco(element.label)) {
                normalizedElements[key] = element;
                return;
            }

            if (element.elementType === 'archivo') {
                element.validators = {
                    ...(element.validators || {}),
                    required: element.validators?.required ?? true,
                };
            } else if (element.elementType === 'radio') {
                element.isRequired = element.isRequired ?? true;
            } else {
                if (Array.isArray(element.validators)) {
                    element.validators = element.validators.includes('required')
                        ? element.validators
                        : [...element.validators, 'required'];
                } else if (element.validators == null) {
                    element.validators = ['required'];
                } else if (typeof element.validators === 'object') {
                    element.validators = {
                        ...element.validators,
                        required: element.validators.required ?? true,
                    };
                }

                element.isRequired = element.isRequired ?? true;
            }

            normalizedElements[key] = element;
        });

        return normalizedElements;
    };

    const [elements,setElements] = React.useState(() => normalizarCamposObligatorios(props.elements));
    const [apiErrors,setApiErrors] = React.useState(props.apiErrors);
    const [listOfFile, setListOfFile] = useState([]);

    const normalizarFecha = (value) => {
        if (!value) return null;

        if (value instanceof Date) {
            if (Number.isNaN(value.getTime())) return null;
            return new Date(value.getFullYear(), value.getMonth(), value.getDate());
        }

        if (typeof value === 'string') {
            const valor = value.trim();

            // dd/MM/yyyy or dd-MM-yyyy
            const matchDMY = valor.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
            if (matchDMY) {
                const day = Number(matchDMY[1]);
                const month = Number(matchDMY[2]) - 1;
                const year = Number(matchDMY[3]);
                const parsed = new Date(year, month, day);

                if (
                    parsed.getFullYear() === year &&
                    parsed.getMonth() === month &&
                    parsed.getDate() === day
                ) {
                    return parsed;
                }
                return null;
            }

            // yyyy/MM/dd or yyyy-MM-dd
            const matchYMD = valor.match(/^(\d{4})[/-](\d{1,2})[/-](\d{1,2})$/);
            if (matchYMD) {
                const year = Number(matchYMD[1]);
                const month = Number(matchYMD[2]) - 1;
                const day = Number(matchYMD[3]);
                const parsed = new Date(year, month, day);

                if (
                    parsed.getFullYear() === year &&
                    parsed.getMonth() === month &&
                    parsed.getDate() === day
                ) {
                    return parsed;
                }
                return null;
            }
        }

        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return null;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const obtenerPrimerMensaje = (mensaje) => {
        if (Array.isArray(mensaje)) return mensaje[0] || '';
        return mensaje || '';
    };

    const validarFechaConReglas = (element, value) => {
        const defaultMessage = obtenerPrimerMensaje(element?.errorMessages);

        if (element?.isRequired && (value === null || JSON.stringify(value) === 'null')) {
            return { isError: true, message: defaultMessage };
        }

        if (!element?.isRequired && (value === null || JSON.stringify(value) === 'null')) {
            return { isError: false, message: defaultMessage };
        }

        const fecha = normalizarFecha(value);
        if (!fecha || fecha?.toLocaleDateString("es-ES")?.match(element?.pattern) === null) {
            return { isError: true, message: obtenerPrimerMensaje(element?.invalidDateErrorMessages) || defaultMessage };
        }

        const hoyDate = new Date();
        const hoy = new Date(hoyDate.getFullYear(), hoyDate.getMonth(), hoyDate.getDate());

        if (element?.disablePast && fecha < hoy) {
            return { isError: true, message: obtenerPrimerMensaje(element?.pastDateErrorMessages) || defaultMessage };
        }

        if (element?.disableFuture && fecha > hoy) {
            return { isError: true, message: obtenerPrimerMensaje(element?.futureDateErrorMessages) || defaultMessage };
        }

        const minDate = normalizarFecha(element?.minDate);
        if (minDate && fecha < minDate) {
            return { isError: true, message: obtenerPrimerMensaje(element?.minDateErrorMessages) || defaultMessage };
        }

        const maxDate = normalizarFecha(element?.maxDate);
        if (maxDate && fecha > maxDate) {
            return { isError: true, message: obtenerPrimerMensaje(element?.maxDateErrorMessages) || defaultMessage };
        }

        return { isError: false, message: defaultMessage };
    };

    const isElementVisibleForValidation = (element) => {
        if (!element) return false;

        switch (element.elementType) {
            case 'texto':
                return element.showInputFormControl !== false;
            case 'areaTexto':
                return element.showInputTextArea !== false;
            case 'fecha':
                return element.showInputDate !== false;
            case 'archivo':
                return element.showInputFile !== false;
            case 'radio':
                return element.mostrarBotonRadio !== false;
            case 'autoCompletar':
                return element.showSelectAutoComplete !== false;
            case 'checkbox':
                return element.showInputCheckox !== false;
            default:
                return true;
        }
    };

    const handleChangeRadio = (event) => {
        const { name, value } = event?.target;
        elements[name].value = value;
        setElements({ ...elements });
        elements[name].handleAction !== undefined && elements[name].handleAction(name, value)
        elements[name].handler !== undefined && elements[name].handler(value)
    };

    const isValidForm=function(){
        var isValid = true;
        Object.keys(elements).forEach(function (key) {
            elements[key].isError= isErrorInElementWithPattern(key, elements[key].value);
            if (isValid===true)    isValid= (elements[key].isError) ? false : true;
        });

        setElements({ ...elements});
        return isValid;
    }

    useEffect(() => {
        setApiErrors(props.apiErrors);
    },[props.apiErrors]);

    useEffect(() => {
        setElements(prev => {
            const nuevo = normalizarCamposObligatorios(props.elements);
            // Preserve user-entered values for fields the parent doesn't track.
            // The parent resets them to null/'' every time its own state changes,
            // but those values only live in Formulario's internal state.
            const tiposInteractivos = ['texto', 'areaTexto', 'archivo', 'fecha', 'autoCompletar', 'selector', 'radio'];
            Object.keys(nuevo).forEach(key => {
                if (!prev[key]) return;
                const prevVal = prev[key].value;
                const nuevoVal = nuevo[key].value;
                const tipo = nuevo[key].elementType;
                if (!tiposInteractivos.includes(tipo)) return;

                const valorVacio = (v) =>
                    v === null || v === '' || v === undefined ||
                    (typeof v === 'object' && !Array.isArray(v) && (v?.id === null || v?.id === undefined || v?.id === ''));

                if (!valorVacio(prevVal) && valorVacio(nuevoVal)) {
                    nuevo[key].value = prevVal;
                    if (tipo === 'archivo' && prev[key].nameOfFile && !nuevo[key].nameOfFile) {
                        nuevo[key].nameOfFile = prev[key].nameOfFile;
                    }
                }
            });
            return nuevo;
        });
    }, [props.elements]);

    const handleChange = (event,self) => {
        const elementName = event.target.name;
        const isCuiField = (elementName || "").toLowerCase().includes("cui");
        const isPhoneField = (elementName || "").toLowerCase().includes("telefono");
        const shouldTransformToUppercase = elements[elementName]?.transformToUppercase === true;
        const transformedValue = shouldTransformToUppercase && typeof event.target.value === 'string'
            ? event.target.value.toUpperCase()
            : event.target.value;

        if (shouldTransformToUppercase) {
            event.target.value = transformedValue;
        }

        const errorInElement = isErrorInElementWithPattern(elementName, transformedValue);

        if (elements[event.target.name].elementType!=="checkbox") {
            if (isCuiField) {
                elements[event.target.name].isError = ((transformedValue === null ? "" : transformedValue?.toString()).match(/^\d{13}$/) === null);
            } else if (isPhoneField) {
                const phoneVal = (transformedValue === null ? "" : transformedValue?.toString());
                const isPhoneRequired = elements[event.target.name].validators?.includes('required');
                
                if (!isPhoneRequired && phoneVal === "") {
                    elements[event.target.name].isError = false;
                } else if (phoneVal === "") {
                    elements[event.target.name].isError = true;
                } else {
                    elements[event.target.name].isError = (phoneVal.match(/^\d{8}$/) === null);
                }
            } else {
                elements[event.target.name].isError = errorInElement;
            }
            elements[event.target.name].value = transformedValue;
        }else{
            var value= JSON.parse(event.target.value.toLowerCase());
            elements[event.target.name].value = (value===elements[event.target.name].value) ? !value : value ;
        }

        if (elements[event.target.name].handler!==undefined){
            event.target.index=parseInt(event.currentTarget.dataset.index);
            elements[event.target.name].handler(event,self);
        }

        if(elements[event.target.name].elementType === "fecha") {
            const {name, value} = event.target;
            const resultadoValidacion = validarFechaConReglas(elements[name], value);
            elements[name].isError = resultadoValidacion.isError;
            elements[name].errorMessages = resultadoValidacion.message;
            elements[name].value = value;
        }

        setElements({ ...elements});

        setApiErrors([]);
    };

    const handleChangeAutocompleteV2 = (event) => {
        const nameTarget = event.target.name;
        const valueTarget = event.target.value;
        const textTarget = event.target.text;

        isErrorInElementWithPattern(nameTarget, { id: valueTarget });

        if (
            elements[nameTarget].showSelectAutoComplete ||
            elements[nameTarget].showSelectAutoComplete !== "undefined"
        ) {
            elements[nameTarget].isError =
                valueTarget === null
                    ? ""
                    : valueTarget?.toString()?.match(elements[nameTarget].pattern) === null
                        ? true
                        : false;
            elements[nameTarget].value = {
                id: valueTarget !== undefined ? (typeof valueTarget === 'string') ? valueTarget : Number(valueTarget) : null,
                name: textTarget,
            };
        }

        if (elements[nameTarget].handler !== undefined) {
            elements[nameTarget].handler(event);
        }

        setElements({ ...elements });
        setApiErrors([]);
    };

    const handleChangeFile = async (event) => {
        if(elements[event.target.name].elementType === "archivo") {

            // get the file currently selected
            const currentFile = event.target.files[0];
            const nameTarget = event.target.name;

            // Reset native file input so selecting the same file again triggers onChange
            event.target.value = null;

            // get the validators of the input file
            const {required, size} = elements[nameTarget].validators;

            // change the values of the file
            elements[nameTarget].isError = false;
            elements[nameTarget].errorMessages = "";
            elements[nameTarget].value = "";

            const oneMegaInBytes = 1048576;

            const existOfTheList = validateExistFileOnList(currentFile, elements[nameTarget].idelement);
            if(existOfTheList?.returnType) {
                elements[nameTarget].isError = true;
                const messageError = `El archivo ${currentFile.name} ya ha sido adjuntado en ${existOfTheList?.nameOnTheList?.label}`;
                elements[nameTarget].errorMessages = messageError;
                setElements({ ...elements});
                return;
            }

            // if the file is not required and No file currently selected for upload'
            if(!required && !currentFile) {
                setElements({ ...elements});
                return;
            }

            // if the file is required and no file currently selected for upload
            if(required && !currentFile) {
                elements[nameTarget].isError = true;
                elements[nameTarget].errorMessages = "Por favor debe adjuntar lo solicitado";
                setElements({ ...elements});
                return;
            }

            const isValidFileType = validateFileType(currentFile, elements[nameTarget])
            if(!isValidFileType) {
                elements[nameTarget].isError = true;
                elements[nameTarget].errorMessages = `Solo de aceptan documentos con extension ${elements[nameTarget].accept}`;
                setElements({ ...elements});
                return;
            }

            const isValidFileSize = validateFileSize(currentFile, size, oneMegaInBytes);
            if(isValidFileSize) {
                elements[nameTarget].isError = true;
                const messageError = `Su archivo pesa ${(currentFile.size / oneMegaInBytes).toFixed(2)} MB y solo se aceptan archivos de ${size}`;
                elements[nameTarget].errorMessages = messageError;
                setElements({ ...elements});
                return;
            }

            const fileInBase64 = await convertBase64(currentFile);
            if (elements[nameTarget].previewUrl && typeof URL !== 'undefined' && typeof URL.revokeObjectURL === 'function') {
                URL.revokeObjectURL(elements[nameTarget].previewUrl);
            }

            const previewUrl = (typeof URL !== 'undefined' && typeof URL.createObjectURL === 'function')
                ? URL.createObjectURL(currentFile)
                : null;

            elements[nameTarget].value = fileInBase64;
            elements[nameTarget].previewUrl = previewUrl;
            elements[nameTarget].nameOfFile = currentFile?.name;

            setElements({ ...elements});
        }
    }

    const handleChangeMultiSelect = (data, name)=>{
        elements[name].value = data;
        elements[name].handler && elements[name].handler(data)
    }

    const handleCheckbox = (event, elemento) => {
        const { name, value } = event?.target;
        elements[name].value = value;

        if (elements[name].listValues?.length > 0) {
            const existValue = elements[name].listValues.some(item => item === value);
            if (existValue) {
                const data = elements[name].listValues.filter(item => item !== value)
                elements[name].listValues = data;
            }
            else elements[name].listValues.push(value)
        } else elements[name].listValues.push(value);

        setElements({ ...elements });
        elements[name].handler !== undefined && elements[name].handler(value, elements[name].listValues, elemento)
    }

    const isErrorInElementWithPattern=(key, value )=>{
        let isError= false;
        const element = elements[key];
        if (!element) return false;

        if (!isElementVisibleForValidation(element)) {
            elements[key].isError = false;
            return false;
        }

        const isCuiField = (key || "").toLowerCase().includes("cui");
        const isPhoneField = (key || "").toLowerCase().includes("telefono");

        if (isCuiField) {
            const cuiValue = (value === null || value === undefined) ? "" : value.toString();
            isError = /^\d{13}$/.test(cuiValue) === false;
            elements[key].value = value;
            elements[key].isError = isError;
            return isError;
        }

        if (isPhoneField) {
            const phoneValue = (value === null || value === undefined) ? "" : value.toString();
            const isPhoneRequired = elements[key].validators?.includes('required');
            
            // Si no es requerido y está vacío, permitir
            if (!isPhoneRequired && phoneValue === "") {
                isError = false;
            } else if (phoneValue === "") {
                // Si es requerido y está vacío
                isError = true;
            } else {
                // Si tiene valor, validar exactamente 8 dígitos
                isError = /^\d{8}$/.test(phoneValue) === false;
            }
            
            elements[key].value = value;
            elements[key].isError = isError;
            return isError;
        }

        switch(elements[key].elementType) {
            case "checkbox":
                if(elements[key]?.isRequired) isError = elements[key]?.listValues?.length <= 0;
                else isError = (((value === null ? "" : value?.toString())?.match(elements[key].pattern)) === null) ? true : false;
                break;
            case "fecha":
                const resultadoValidacionFecha = validarFechaConReglas(elements[key], value);
                isError = resultadoValidacionFecha.isError;
                elements[key].errorMessages = resultadoValidacionFecha.message;
                elements[key].value = value;
                break;
            case "hidden":
                isError=false;
                elements[key].value = value;
                break;
            case "archivo" :
                const isRequired = elements[key].validators?.required;
                isError = (!value && isRequired);
                elements[key].value = value;
                elements[key].errorMessages = "Por favor debe adjuntar lo solicitado";
                break;
            case "radio" :
                isError = (elements[key]?.isRequired && !value);
                elements[key].value = value;
                break;
            case "editor" :
                if(elements[key].isRequeried) {
                    let myHTML= value;
                    let strippedHtml = myHTML.replace(/<[^>]+>/g, '');
                    isError = !strippedHtml ? true : false;
                }
                elements[key].value = value;
                break;
            case "autoCompletar":
                isError = !elements[key].pattern
                ? false
                : value != null || value != undefined
                    ? value?.id?.toString().match(elements[key].pattern) === null
                        ? true
                        : false
                    : true;
                elements[key].value = value;
                break;
            case "selectMultiple":
                isError = elements[key].isRequired ? (!value || value?.length === 0) ? true : false : false;
                break;
            default:
                isError= (( (value ===null ? "": value?.toString())?.match(elements[key].pattern))===null) ? true : false;
                elements[key].value = value;
                break;
        }
        elements[key].isError= isError;
        return isError;
    }

    const saveAndClean= function(){
        var isValid = isValidForm();
        if(isValid===true)  props.saveAndClean(getData(),false);
    }

    const getData=function(){
        var data = {};
        Object.keys(elements).map(key => data[key]=elements[key].value)
        return data;
    }

    const cancelAction = function() {
        const dataForm = getData()
        Object.keys(elements).forEach( item => {
            elements[item].isError = false;
            if(elements[item].elementType === "fecha") elements[item].value = null;
            else if(elements[item].elementType === "radio") elements[item].value = null;
            else elements[item].value = ""
            setElements({ ...elements});
        })
        return dataForm;
    }

    const saveAndBack = function(){
        var isValid = isValidForm();
        if(isValid) props.saveAndBack(getData(),true);
    }

    const getApiErrorByKeyElement=(key)=>{
        let data ={"message":null, 'isError':false}
        if (apiErrors===null || apiErrors===undefined || apiErrors.length===0) return data;
        apiErrors.forEach(item => {
            if (key===item.attribute){
                data.message=item.message;
                data.isError=true;
            }
        });
        return data;
    }

    let buttonListHtml =(props.buttonList!==undefined) ? Object.keys(props.buttonList).map(key => {
        let item=props.buttonList[key];
        return (
            <Button
                name={key} key={key}
                variant="contained"
                style={{    color: (item.color!==undefined) ?  item.color :"",
                            background:(item.background!==undefined) ?  item.background :"",
                            display:(item.display!==undefined) ? item.display :"",
                            justifyContent:(item.justifyContent!==undefined) ? item.justifyContent :"",
                            width: (item.width!==undefined) ? item.width :"",
                        }}
                className={classes.button}
                size={item.size}
                onClick={()=>{
                    if(item?.isCancel || item?.sendData) {
                        item.callback(cancelAction())
                        return;
                    }

                    var isValid = isValidForm();
                    if(isValid)  item.callback(getData());
                }}
                disabled={item.disabled}
            >
                    {item.loading ?  (<div className={classes.circularProgress}><CircularProgress /></div>) : (<Icon style={{marginRight: '10px'}}>{item.icon}</Icon>) }
                    {" "+item.label}
            </Button>
        )
    }) : "";

    var htmlControls =  Object.keys(elements).map(key => {

        let messageError= elements[key].errorMessages,
            isError = elements[key].isError;

        let apiErrorOfKey= getApiErrorByKeyElement(key);
        if (apiErrorOfKey.isError){
            messageError=apiErrorOfKey.message;
            isError=true;
        }

        switch(elements[key].elementType) {
            case "texto": return(
                <FormControlDeEntrada
                    key={elements[key].idelement} label={elements[key].label}
                    name={elements[key].idelement} value={elements[key].value}
                    handleChange={handleChange} errorMessages={messageError}
                    this={elements[key]["this"]} isError={isError}
                    keyPress={elements[key].keyPress}
                    disabled={elements[key].disabled}
                    autofocus={elements[key].autofocus}
                    multiline={elements[key].multiline}
                    maxLength={elements[key].maxLength}
                    showInputFormControl={elements[key].showInputFormControl}
                    width={elements[key].width}
                    marginTop={elements[key].marginTop}
                    manejadorDeCambio={elements[key].manejadorDeCambio}
                ></FormControlDeEntrada>
            );
            case "numero": return(
                <FormControlNumerico
                    key={key} label={elements[key].label} isError={isError}
                    name={elements[key].idelement} value={elements[key].value}
                    handleChange={handleChange} errorMessages={messageError}
                    this={elements[key]["this"]}
                    keyPress={elements[key].keyPress}
                    disabled={elements[key].disabled}
                    elementType={elements[key].elementType}
                ></FormControlNumerico>
            );
            case "password": return(
                <FormControlDeContrasena
                    key={key} label={elements[key].label} isError={isError}
                    name={elements[key].idelement} value={elements[key].value}
                    handleChange={handleChange}
                    keyPress={elements[key].keyPress}
                    errorMessages={messageError}
                    width={elements[key].width}
                    marginTop={elements[key].marginTop}
                ></FormControlDeContrasena>
            );
            case "dropdown": return(
                <FormSeleccionar
                    className={classes.select} key={key} label={elements[key].label} isError={isError}
                    name={elements[key].idelement} value={elements[key].value}
                    handleChange={handleChange} errorMessages={messageError} list={elements[key].list}
                    onChange={ (elements[key].handler!==undefined) ? elements[key].handler : null }
                    this={elements[key]["this"]}
                    disabled={elements[key].disabled}
                ></FormSeleccionar>
            );
            case "checkbox": return(
                <InputCheckbox
                    key={key}
                    label={elements[key].label}
                    idelement={elements[key].idelement}
                    value={elements[key].value}
                    options={elements[key].options}
                    isError={elements[key].isError}
                    errorMessages={elements[key].errorMessages}
                    handleCheckbox={handleCheckbox}
                    name={elements[key].idelement}
                    showInputCheckox={elements[key].showInputCheckox}
                    width={elements[key].width}
                    numberColumns={elements[key].numberColumns}
                />
            );
            case "fecha": return(
                <FormSelectorDeFechas
                    key={key}
                    label={elements[key].label}
                    isError={isError}
                    name={elements[key].idelement}
                    value={elements[key].value}
                    handleChange={handleChange}
                    errorMessages={messageError}
                    disabled={elements[key].disabled}
                    width={elements[key].width}
                    manejadorDeCambio={elements[key].manejadorDeCambio}
                    disableFuture={elements[key].disableFuture}
                    disablePast={elements[key].disablePast}
                    maxDate={elements[key].maxDate}
                    minDate={elements[key].minDate}
                    views={elements[key].views}
                    showInputDate={elements[key].showInputDate}
                ></FormSelectorDeFechas>
            )
            case "archivo": return (
                <FormInputArchivos
                    key={elements[key].idelement}
                    fileWidth={elements[key].fileWidth}
                    label={elements[key].label}
                    name={elements[key].name}
                    multiple={elements[key].multiple}
                    elementType={elements[key].elementType}
                    accept={elements[key].accept}
                    handleChangeFile={handleChangeFile}
                    src={elements[key].src || "/menu/plan_de_medios_alternativos.png"}
                    isError={elements[key].isError}
                    errorMessages={elements[key].errorMessages}
                    showInputFile={elements[key].showInputFile}
                    value={elements[key].value}
                    fileType={elements[key].fileType}
                    showInMovil={elements[key].showInMovil}
                    width={elements[key].width}
                    type={elements[key].type}
                    disabled={elements[key].disabled}
                    handleVisualization={elements[key].handleVisualization}
                    disabledVisualization={elements[key].disabledVisualization}
                    nameOfFile={elements[key].nameOfFile}
                    previewValue={elements[key].previewUrl || elements[key].value}
                />
            )
            case "radio": return(
                <FormBotonRadio
                    key={elements[key].idelement}
                    label={elements[key].label}
                    idelement={elements[key].idelement}
                    value={elements[key].value}
                    handleChangeRadio={handleChangeRadio}
                    options={elements[key].options}
                    isError={elements[key].isError}
                    errorMessages={elements[key].errorMessages}
                    mostrarBotonRadio={elements[key].mostrarBotonRadio}
                    disabled={elements[key].disabled}
                />

            )
            case "titulo": return (
                <Fragment key={elements[key].idelement}>
                {elements[key].showTitleForm && (
                    <div style={{ textAlign: elements[key].position, width: elements[key]?.widthTitleForm ? elements[key].widthTitleForm : '100%' }} className={classes.title} key={elements[key].idelement}>
                        <strong>{elements[key].title}</strong>
                    </div>
                )}
                </Fragment>
            );
            case "alerta": return (
                <div key={elements[key].idelement} style={{width: elements[key].width ? elements[key].width : '90%', marginBottom: '5px', }}>
                {elements[key].showAlertForm && (
                    <Alert
                        key={elements[key].idelement}
                        variant="filled"
                        severity={elements[key].severity}
                    >
                        {elements[key].mensaje}
                    </Alert>
                )}
                </div>
            );
            case "autoCompletar": return (
                <FormAutocompletar
                    key={elements[key].idelement}
                    className={classes.select}
                    label={elements[key].label}
                    isError={isError}
                    name={elements[key].idelement}
                    value={elements[key].value}
                    handleChange={handleChangeAutocompleteV2}
                    errorMessages={messageError}
                    list={elements[key].list}
                    onChange={ elements[key].handler !== undefined ? elements[key].handler : null }
                    disabled={elements[key].disabled}
                    position={elements[key].position}
                    showSelectAutoComplete={elements[key].showSelectAutoComplete}
                    autoFocus={elements[key].autoFocus}
                    width={elements[key].width}
                    marginTop={elements[key].marginTop}
                ></FormAutocompletar>
            );
            case "areaTexto": return (
                <FormAreaTexto
                    key={elements[key].idelement}
                    label={elements[key].label}
                    isError={isError}
                    name={elements[key].idelement}
                    value={elements[key].value}
                    handleChange={handleChange}
                    errorMessages={messageError}
                    this={elements[key]["this"]}
                    disabled={elements[key].disabled}
                    autofocus={elements[key].autofocus}
                    showInputTextArea={elements[key].showInputTextArea}
                    maxRows={elements[key].maxRows}
                    minRows={elements[key].minRows}
                    width={elements[key].width}
                />
            )
            case "selectMultiple" : return (
                <FormAutocompletarMultiple
                    key={key}
                    elementType={elements[key].elementType}
                    list={elements[key].list}
                    label ={elements[key].label}
                    name={elements[key].name}
                    isRequired={elements[key].isRequired}
                    isError={elements[key].isError}
                    errorMessages={elements[key].errorMessages}
                    value={elements[key].value}
                    handleChangeMultiSelect={handleChangeMultiSelect}
                />
            )
            case "boton" : return (
                <TooltipPersonalizado
                    key={elements[key].idelement}
                    title={elements[key].title}
                    fontSize={elements[key].fontSize}
                    color={elements[key].color}
                    marginTop={elements[key].marginTop}
                    handleFunction={elements[key].handleFunction}
                    icon={elements[key].icon}
                />
            )
            default: return(null);
        }
    });

    /** FUNCTION TO VALIDATE FILE TYPE
    * description fucntion to validate file type
    * params
    *   currentFile = currentFile is the file currently selected,
    *   element = is the input file of the form
    */
    const validateFileType = (currentFile, element) => {
        const fileAccept =  element.accept ? element.accept.split(', ') : [];
        const fileType = currentFile.name.split('.').reverse()[0];
        return fileAccept.includes(`.${fileType}`);
    }

    /** FUNCTION TO VALIDATE FILE SIZE
    * description fucntion to validate file size
    * params
    *   currentFile = currentFile is the file currently selected,
    *   sizeAccepted = is the size accepted of the file in MB
    */
    const validateFileSize = (currentFile, sizeAccepted, oneMegaInBytes) => {
        const splitSize = sizeAccepted.split(' ');
        const sizeFile = (splitSize.length === 1) ? oneMegaInBytes : Number(splitSize[0]) *  oneMegaInBytes;
        return currentFile.size > sizeFile;
    }

    /** FUNCTION TO VALIDATE FILE EXIST IN THE LIST
    * description fucntion to validate that file no exist in the list
    * params
    *   currentFile = currentFile is the file currently selected,
    *   idElement =  the unique ID of the file
    */
    const validateExistFileOnList = (currentFile, idElement) => {
        // Keep only files that still exist in current form state to avoid stale memory.
        const currentFilesMap = Object.keys(elements).reduce((acc, key) => {
            const element = elements[key];
            if (element?.elementType === 'archivo' && element?.nameOfFile) {
                acc[element.idelement] = element.nameOfFile;
            }
            return acc;
        }, {});

        const cleanedListOfFile = listOfFile.filter((item) => currentFilesMap[item.idelement] === item.name);

        // Remove current file element tracking first so replacing/reselecting the same file in same field is allowed.
        const listWithoutCurrentElement = cleanedListOfFile.filter((item) => item.idelement !== idElement);

        // validate that current file is null
        if(!currentFile) {
            setListOfFile(listWithoutCurrentElement);
            return { returnType: false, nameOnTheList: undefined };
        }

        // check file name element doesn't exist in other file fields
        const nameOnTheList = listWithoutCurrentElement.find(item => item.name === currentFile.name);
        if(nameOnTheList) {
            setListOfFile(listWithoutCurrentElement);
            return { returnType: true, nameOnTheList };
        }

        setListOfFileAction(listWithoutCurrentElement, currentFile, idElement);
        return { returnType: false, nameOnTheList: undefined };
    }

    // Function to set element in file list
    const setListOfFileAction = (newList, currentFile, idElement) => {
        setListOfFile([...newList, {idelement: elements[idElement].idelement, name: currentFile.name, label: elements[idElement].label}])
    }

    // Function to check file id element exist in file list
    const existeIDElementOfTheList = (idElement, returnType, nameOnTheList) => {
        const existOnTheList = listOfFile.some( item => item.idelement === idElement);
        if(existOnTheList) {
            const newListOfFile = listOfFile.filter( item => item.idelement !== idElement)
            setListOfFile(newListOfFile);
            return {returnType, nameOnTheList};
        }
        return {returnType, nameOnTheList};
    }

    /** FUNCTION TO CONVERT FILE TO BASE 64
    * description = Function to convert file to base 64
    * params
    *   file = currentFile is the file currently selected,
    */
    const convertBase64 = (file) => {
        if(file){
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onload = () => { resolve(fileReader.result); };
                fileReader.onerror = (error) => { reject(error);    };
            });
        }
    };

    return (
        <div className={(props.hideInPrintView)===true ?classes.hideInPrintView+" "+classes.root: classes.root}>
            <div className={classes.formContainer}>
                {htmlControls}
            </div>
            <div className={classes.buttonContainer}>
                {buttonListHtml}
            </div>
            <div className={classes.buttonContainer}>
                {props.showButton1 && props.saveAndClean ? (
                    <Button variant="contained" color="primary" className={classes.button} onClick={saveAndClean}>
                        {props.iconSaveAndClean ? ( <Icon>{props.iconSaveAndClean}</Icon> ) : ( <SaveIcon className={clsx(classes.leftIcon, classes.iconSmall)} /> )}
                        {props.titleSaveAndClean}
                    </Button>
                ):""}
                {props.showButton && props?.sendData ? (
                    <Button variant="contained" color="primary" className={classes.button} onClick={props.sendData}>
                        <SaveIcon className={clsx(classes.leftIcon, classes.iconSmall)} />
                        {props.titleSendData}
                    </Button>
                ):""}
                {props.showButton2 ? (
                    <Button variant="contained" color="primary" className={classes.button} onClick={props.handleClick2}>
                        <SaveIcon className={clsx(classes.leftIcon, classes.iconSmall)} />
                        {props.titleButton2}
                    </Button>
                ):""}
                {props.saveAndBack ? (
                    <Button variant="contained" color="primary" className={classes.button} onClick={saveAndBack}>
                        <SaveIcon  />
                        Guardar y regresar
                    </Button>
                ):""}

                {props.handleShowList ? (
                    <Button variant="contained"  className={classes.buttonCancel}
                    onClick={props.handleShowList} >
                    <CancelIcon className={classes.leftIcon} />
                    Cancelar
                </Button>
                ):("")}
            </div>
        </div>
    );
}